import React from 'react';

// External libs
import { useState, useEffect } from "react";

// decode the tenant id for the display config 
import { jwtDecode } from "jwt-decode";

// backend service
import { loadTenantConfig } from "../services/tenantService.js";

// widget components
import WidgetWrapperMapReadings from "../components/widgets/widgetMap/WidgetWrapperMapReadings.js";
import WidgetRenderer from "../components/WidgetRenderer.js";

// main page components
import WidgetDeviceSummary from "../components/widgets/WidgetDeviceSummary.js"
import DeviceListPanel from "./DeviceListPanel.js";

function DefaultLandingPage() {
  const [selectedDevObj, setSelectedDevObj] = useState(null);

  const [config, setConfig] = useState(null);

  const summarySection = config?.ui?.info?.summarySection;
  const chartSection = config?.ui?.info?.chartSection;
  
  useEffect(() => {

    if (!selectedDevObj) return;
    
    const token = sessionStorage.getItem('jwtToken');
    const decoded = jwtDecode(token);

    async function loadConfig() {
      const cfg = await loadTenantConfig(
        decoded.tenantName,
        selectedDevObj?.deviceType
      );

      setConfig(cfg);
    }

    loadConfig();
  }, [selectedDevObj]);

  return (
    <div className="dashboard">
      <div className="widget-container">
        {/* Row 1 for Device List and Config Status */}
        <DeviceListPanel
          onSelectedDevObj={setSelectedDevObj}
        />
        {/* End of Row 1 for Device List Panel*/}

        {/* Device Control, Map, and Individual Widgets */}
        {(selectedDevObj &&
        <div className="config-container">
          {/* Row 1 for Device Config and Status and Map */}
          <div className="widget-container">
            {/* Device Config and Status */}
            <div className="widget-box widget-box-1/2">
              {(selectedDevObj &&
              <WidgetDeviceSummary 
                deviceId={selectedDevObj?.id ?? null}
              />
              )}
            </div>

            {/* Map Widget */}
            <div className="widget-box widget-box-1/2">
              <WidgetWrapperMapReadings
                deviceId={selectedDevObj?.id ?? null}
              />
            </div>
          </div>

          {/* Individual Widgets */}
          <div className="widget-container">
            {/* Summary section */}
            {summarySection?.widgets.map(widget => (
              <div key={widget.id} className="widget-box widget-box-1/5">
                <WidgetRenderer
                  widget={widget}
                  device={selectedDevObj}
                  deviceId={selectedDevObj?.id ?? null}
                  outputs={config?.outputs}
                />
              </div>
            ))}
          </div>
          {/* End of Individual Widgets Row */}
        </div>
        )}
        {/* End of config-container*/}
      </div>

      {/* End of widget-container of the upper screen */}

      {/* Hightlighted Graph */}
      {(selectedDevObj &&
      <div className="widget-container">
        {chartSection?.widgets.map(widget => (
        <div key={widget.id} className="widget-box widget-box-1/2">
          <WidgetRenderer
            widget={widget}
            device={selectedDevObj}
            deviceId={selectedDevObj?.id ?? null}
        />
        </div>
        ))}
      </div>
      )}
    </div>
  );
}
export default DefaultLandingPage;
